import cn from 'classnames';
// Ui
import Button from 'ui3/Button/Button';
// Styles
import styles from './MerchOptions.module.scss';

export type MerchOption = {
  value: string;
  isSelected: boolean;
};

type MerchOptionsProps = {
  isYouth?: boolean;
  options: MerchOption[];
  handleSelectOption: (option: string) => void;
};

const MerchOptions = ({
  options,
  handleSelectOption,
  isYouth = false,
}: MerchOptionsProps) => {
  const onButtonClick = ({ value, isSelected }: MerchOption) => {
    if (!isSelected) {
      handleSelectOption(value);
    }
  };

  return (
    <div className={styles.optionsContainer}>
      {options.map(({ value, isSelected }, index) => {
        return (
          <Button
            key={index}
            className={cn(styles.option, {
              [styles.selected]: isSelected,
            })}
            variant="secondary"
            size="small"
            onClick={() => {
              onButtonClick({ value, isSelected });
            }}
          >
            {isYouth && value === 'Unisex' ? 'Youth' : value}
          </Button>
        );
      })}
    </div>
  );
};

export default MerchOptions;
